const locale = {
  placeholder: 'Select a time range',
  label_last1Hour: 'Last 1 hour',
  label_last6Hours: 'Last 6 hours',
  label_last24Hours: 'Last 24 hours',
  label_last2Days: 'Last 2 days',
  label_last3Days: 'Last 3 days',
  label_last7Days: 'Last 7 days',
  label_last15Days: 'Last 15 days',
  label_last30Days: 'Last 30 days',
  label_weekToCurrentDate: 'Week to date (WTD)',
  label_monthToCurrentDate: 'Month to date (MTD)',
  label_today: 'Today',
  label_currentMonth: 'Current month',
  label_custom: 'Custom time range',
  label_timeZone: 'Time zone',
  label_localTime: 'Local time',
  startTimeError: 'Cannot be earlier than {earliestTime}',
  endTimeError: 'Cannot be later than {latestTime}',
  rangeError: 'Time range must be within ',
  label_from: 'From',
  label_to: 'To',
  button_apply: 'Apply',
  label_otherActions: 'Quick settings',
  label_yesterday: 'Yesterday',
  label_previousWeek: 'Last Week',
  label_previousMonth: 'Last Month'
};
export default locale;